import { Component, Input, OnInit } from '@angular/core';

import { RestaurantService } from './restaurant.service';

import { RestaurantDescription } from './restaurant-description';

import 'rxjs/add/operator/switchMap';

@Component({
	selector: 'description',
	templateUrl: './description.component.html',
	styleUrls: ['./description.component.css']
})

export class DescriptionComponent implements OnInit {

	constructor(
		private m_restaurant_service: RestaurantService,
  	) {}
	m_descriptions: RestaurantDescription[];

	ngOnInit(): void {
		this.getRestaurant();
	}

	getRestaurant(): void {
		this.m_restaurant_service.getRestaurant(this.m_restaurant_service.name).then(
			restaurant => {
				this.m_descriptions = restaurant.description
			}
		);
	}
}


// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/description.component.ts